import { render } from "./AllMenus.vue?vue&type=template&id=61485b56&scoped=true"
import script from "./AllMenus.vue?vue&type=script&lang=js"
export * from "./AllMenus.vue?vue&type=script&lang=js"

import "./AllMenus.vue?vue&type=style&index=0&id=61485b56&scoped=true&lang=scss"

import exportComponent from "/Users/macbook/Documents/personal/freelance-sabdulla/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61485b56"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTd from 'quasar/src/components/table/QTd.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QTable,QInput,QIcon,QTd});
